import { format } from 'date-fns/esm';
import { Box, Card, Typography } from '@mui/material';

import { IPatientInfo } from 'apis/admin/type';

interface Props {
  patientInfo: IPatientInfo;
}

const MedicalNote = ({ patientInfo }: Props) => {
  const today = format(new Date(), 'yyyy-MM-dd');
  const rawNote = patientInfo.medical_note ?? '';
  const normalizedNote = rawNote
    .replace(/\r\n/g, '\n')
    .replace(/\\n/g, '\n');
  const noteLines = normalizedNote.split('\n');

  return (
    <Box flex={1.2} display="flex" flexDirection="column" overflow="auto">
      <Card
        component="section"
        sx={{ p: '20px 15px', height: '100%', overflow: 'auto' }}
      >
        <Typography variant="subtitle2" fontSize={13} mb={1}>
          Patient status and prescription details, etc.
        </Typography>
        <Typography variant="caption" component="p" color="#00000080" mb={1}>
          Date and Time of Prescription {today}
        </Typography>
        {normalizedNote ? (
          noteLines.map((line, idx) => (
            <Typography
              key={idx}
              variant="body2"
              lineHeight="22px"
              whiteSpace="pre-wrap"
              sx={{
                py: 0.8,
                borderBottom:
                  idx === noteLines.length - 1
                    ? 'none'
                    : '1px solid rgba(0, 0, 0, 0.08)',
              }}
            >
              {line || '\u00A0'}
            </Typography>
          ))
        ) : (
          <Typography variant="body2" color="#00000061">
            No prescription or memo has been entered.
          </Typography>
        )}
      </Card>
    </Box>
  );
};

export default MedicalNote;
